import { useContext } from 'react';
import { MapContext } from '../../contexts/map';
import { useDrawLocationsOnMap } from './effects';

export default function Locations({ locations }) {
  const { map } = useContext(MapContext);
  useDrawLocationsOnMap(map, locations);
  return null;
}
